import { Link } from 'react-router-dom';
import logo from '../../assets/feedaia-dark-logo.svg';
import { OnboardingBlock, FormCol } from './OnboardingTemplate.styles';

function OnboardingTemplate({ children }) {
  return (
    <OnboardingBlock>
      <FormCol>
        <div className="form-content">
          <Link
            className="brand_logo"
            href="/"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              fontFamily: "'Bricolage Grotesque', sans-serif",
              fontWeight: 800,
              fontSize: '1.4rem',
              letterSpacing: '-0.04em',
              textDecoration: 'none',
              color: '#0E0E0C',
            }}>
            <span
              style={{
                width: 28,
                height: 28,
                background: '#0E0E0C',
                borderRadius: 8,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                position: 'relative',
              }}>
              <span
                style={{
                  width: 12,
                  height: 12,
                  background: '#D6FF3D',
                  borderRadius: 3,
                  transform: 'rotate(45deg)',
                  display: 'block',
                }}
              />
            </span>
            Appgentic
          </Link>
          {children}
        </div>
      </FormCol>
    </OnboardingBlock>
  );
}

export default OnboardingTemplate;
